﻿$.fn.dxCtrlPagePlanitiReunionExterneChoixReprogrammation = function custom_dxCtrlPagePlanitiReunionExterneChoixReprogrammation(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpageplanitireunionexternechoixreprogrammation dx-ctrl");
        this.createInstance(new cdxCtrlPagePlanitiReunionExterneChoixReprogrammation(this, option));
    }
    return this;
}

window.cdxCtrlPagePlanitiReunionExterneChoixReprogrammation = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dataPlanitiReunion = null

    var dxNomStructure = null
    var dxNomPrenom = null
    var dxEmail = null
    var dxAdrPostale = null
    var dxSiteWeb = null
    var dxTelFixe = null
    var dxMobile = null
    var dxTagBoxInvite = null
    var dxLieu = null
    var dxTextInfo = null
    function mConstruit() {
        container.empty();
        container.css("position", "relative")
        container.css("text-align", "left")

        option.bddCtrl.mAjaxCall({ command: "getdataplanitireunion", id_planiti_reunion: option.idPlanitiReunion }, function (data) {
            dataPlanitiReunion = data
            mRempli()
            if (typeof option.onContentReady != 'undefined') option.onContentReady({ component: Me })
        })

    }

    var dxTextInfo = null
    function mRempli() {
        $("<div style='position:sticky;top:0;left:0;z-index:2;width:40px;'/>").appendTo(container).dxCtrlButton({
            icon: "fas fa-arrow-left",
            hint: "Choisir une autre date ou un autre créneau",
            onClick: function (e) {
                option.onCancel()
            }
        }).dxCtrlButton("instance")

        var $DivContainer = $("<div style='margin-left:40px;'/>").appendTo(container)

        $("" +
            "<div style='padding-bottom:10px;'>" +
            "<div style='font-size:160%;font-weight:bold;'>Reprogrammer la réunion</div>" +
            "<div style='opacity:0.3;text-decoration:line-through;'>DU <b>" + DevExpress.localization.formatDate(option.dateDebutOrigineReprogrammation, "eeee d MMMM yyyy") + "</b> de <b>" + DevExpress.localization.formatDate(option.dateDebutOrigineReprogrammation, "HH:mm") + "</b> à <b>" + DevExpress.localization.formatDate(option.dateFinOrigineReprogrammation, "HH:mm") + "</b></div>" +
            "AU <b>" + DevExpress.localization.formatDate(option.dat, "eeee d MMMM yyyy") + "</b> de <b>" + DevExpress.localization.formatDate(option.dat, "HH:mm") + "</b> à <b>" + DevExpress.localization.formatDate((new Date(option.dat)).addMinutes(option.dataPlaniti.planiti.duree_reunion_mn), "HH:mm") + "</b><br/>" +
            "</div>" +
            "").appendTo($DivContainer)

        $("<div style='font-weight:bold;font-size:120%;margin:25px 0 5px 0;'>Partager les informations qui nous permettrons de préparer la réunion</div>").appendTo($DivContainer)
        //$("<div style='font-style:italic;font-size:90%;'>Partager les informations qui nous permettrons de préparer la réunion.</div>").appendTo($DivContainer)
        dxTextInfo = $("<div/>").appendTo($DivContainer).dxCtrlTextBox({
            label: "Partager les informations qui nous permettrons de préparer la réunion",
            labelMode: 'hidden',
            multiline: true,
            minHeight: 200,
            value: dataPlanitiReunion.planiti_reunion[0].text_info,
        }).dxCtrlTextBox("instance")

        if (dataPlanitiReunion.planiti[0].nbre_organisateur == 1) {
            $("<div style='margin:25px 0 10px 0;'/>").appendTo($DivContainer).dxCtrlButton({
                text: "Reprogrammer la réunion",
                onClick: function (e) {
                    mValideReprogrammation()
                }
            })
        }

    }

    function mValideReprogrammation() {
        option.jauge.mShow()
        var dateDebut = option.dat
        var dateFin = (new Date(option.dat)).addMinutes(option.dataPlaniti.planiti.duree_reunion_mn)
        var dataToBeSend = {
            command: "updatedateplanitireunion",
            id_planiti: option.dataPlaniti.planiti.id_planiti,
            id_planiti_reunion: dataPlanitiReunion.planiti_reunion[0].id_planiti_reunion,
            id_planiti_reunion_orga: dataPlanitiReunion.planiti_reunion_orga[0].id_planiti_reunion_orga,
            date_debut: dateDebut,
            date_fin: dateFin,
            text_info: dxTextInfo.option("value")
        }
        option.bddCtrl.mAjaxCall(dataToBeSend, function (data) {
            if (data.creneaupris == "1") {
                mNotify("Le créneau que vous avez choisi a été réservé. Veuillez choisir un autre créneau.", "error", 6000)
                option.onCancel()
            } else if (data.ok == "0") {
                mNotify("Impossible de modifier la date du rendez-vous.", "error", 6000)
            } else {
                option.onValidateReprogrammation(data.id_planiti_reunion, dateDebut, dateFin)
            }
        }, function () {
            option.jauge.mHide()
        })
    }

    this.element = function () { return container; }

    mConstruit();
}